var MLCV = MLCV || {};

jQuery(document).ready(function () {
    //Create the SHOW/HIDE Element
    $anchorShowHide = jQuery('<a>').addClass('toggle-show-hide').attr({
        "href": "javascript:void(0);",
        "title": "SHOW FORM",
        "data-show": "SHOW FORM",
        "data-hide": "HIDE FORM"
    }).text("SHOW FORM");

    $showHide = jQuery('<div>').addClass('show-more-link').append($anchorShowHide);
    $showHide.insertAfter('.peopSearSect .contactUsForm .enterBtn');

    //SET FORM FIELDS WIDTH
    jQuery('.oneHalf #Subject').parent().css({ 'width': '100%' });
    jQuery('.oneHalf #FirstName').parent().css({ 'width': '100%' });
    jQuery('.oneHalf #LastName').parent().css({ 'width': '100%' });
    jQuery('.oneHalf #Phone').parent().css({ 'width': '100%' });
    jQuery('.oneHalf #ContactEmail').parent().css({ 'width': '100%' });

    jQuery('#TellUs').parent().css({ 'width': '100%' });
    jQuery('.captField').parent().css({ 'width': '100%' });
    jQuery('.mandatory-mess').css({ 'width': '100%' });
    jQuery('.enterBtn').css({ 'width': '100%' });

    var companyName = jQuery('.oneHalf #CompanyName');
    var emailToVal = jQuery('#InquiryType option:contains("Site Related Inquiry")').val();

    $("#InquiryType").val(emailToVal);
    companyName.val('N/A');

    jQuery('div.show-more-link a').css({ 'background': 'url(../contents/images/plus-minus-icon.png) no-repeat 0 4px' });

    jQuery('div.show-more-link a').click(function () {
        jQuery('.oneHalf #Subject').parent().toggle();
        jQuery('.oneHalf #FirstName').parent().toggle();
        jQuery('.oneHalf #LastName').parent().toggle();
        jQuery('.oneHalf #Phone').parent().toggle();
        jQuery('.oneHalf #ContactEmail').parent().toggle();
        jQuery('.peopSearSect #divContactUs .validation-summary').toggle();

        jQuery('#TellUs').parent().toggle();
        jQuery('.captField').parent().toggle();
        jQuery('.mandatory-mess').toggle();
        jQuery('.enterBtn').toggle();

        if (this.title == "SHOW FORM") {
            jQuery(this).attr('title', 'HIDE FORM');
            jQuery(this).text('HIDE FORM');
            jQuery(this).css({ 'background-position-y': '-146px' });
        } else {
            jQuery(this).attr('title', 'SHOW FORM');
            jQuery(this).text('SHOW FORM')
            jQuery(this).css({ 'background-position-y': '-96px' });
        }
    });

    $("body").click(function (e) {
        if (e.target.className !== "toggle-show-hide") {
            if (jQuery('div.show-more-link a').attr('title') == "SHOW FORM") {
                jQuery('div.show-more-link a').css({ 'background-position-y': '4px' });
            } else {
                jQuery('div.show-more-link a').css({ 'background-position-y': '-47px' });
            }
        } else {
            if (this.title == "SHOW FORM") {
                jQuery(this).css({ 'background-position-y': '-146px' })
            } else {
                jQuery(this).css({ 'background-position-y': '-96px' });
            }
        }
    });

    if (jQuery('.validation-summary #captchaError').text() != "") {
        //OPEN FORM
        jQuery('.oneHalf #Subject').parent().show();
        jQuery('.oneHalf #FirstName').parent().show();
        jQuery('.oneHalf #LastName').parent().show();
        jQuery('.oneHalf #Phone').parent().show();
        jQuery('.oneHalf #ContactEmail').parent().show();
        jQuery('.peopSearSect #divContactUs .validation-summary').show();

        jQuery('#TellUs').parent().show();
        jQuery('.captField').parent().show();
        jQuery('.mandatory-mess').show();
        jQuery('.enterBtn').show();

        jQuery('div.show-more-link a').attr('title', 'HIDE FORM');
        jQuery('div.show-more-link a').text('HIDE FORM');
        jQuery('div.show-more-link a').css({ 'background-position-y': '-47px' });
        jQuery('div.show-more-link a').parent().css({ 'padding-top': '75px !important' });
        
    }
});